



























































import { Component, Vue,Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import moment from "moment";
import { store, StoreState } from "../../store";
import util from "../../lib/util"; 

@Component({
  components: {},
  computed: {
    ...mapState({
      conferenceattendeesectionlist: (state: StoreState) => state.dashboard.AttendeeSectionList,
      conferencedata: (state: StoreState) => state.dashboard.ConferenceData,
      Confrence_On: (state: StoreState) => state.dashboard.Confrence_On,
      ConferecneParticipantList: (state: StoreState) => state.dashboard.ConferecneParticipantList
    })
  }
})
export default class Bridge extends Vue {
  privateConfDuration: string = "";
  data() {
    return {
      Mute_All: false,
      Lock: false,
      Conference_ownername: "",
      Conference_Duration: "",
      styleobj: { "background-color": "" },
      loadingadd: false,
      loadingmick: false,
      loadingheadphn: false,
      loading_statusbyid: "",
      spinIMG: "img/icons/spinn_icon.gif",
      muteall_loading:false,
      Unlockall_loading:false
    };
  }

      @Watch('conferencedata')
        SetConferencedata() {
          this.$store.dispatch("createBlackholeSocket");
            this.reloadData( (this as any).conferencedata);
            this.$store.commit("SET_ADMIN_LOADER", false);
        }

        @Watch('Confrence_On')
        setConferenceDurationTick()
        {
            var conferenceon= (this as any).Confrence_On;
            var dur=this.$data.Conference_Duration
             if (conferenceon && dur ==0) {
                  let ms: any = moment.duration(dur, "seconds");
                  setInterval(() => {
                  this.$data.Conference_Duration = this.alterTime(ms);
                  ms._milliseconds += 1000;
                }, 1000);
             }
        }

        @Watch('ConferecneParticipantList')
        ConferecneParticipantl(){
         if((this as any).ConferecneParticipantList.length!=0){
         var mute_list= (this as any).ConferecneParticipantList.filter(e => e.speak == false).length;
         this.$data.Mute_All=mute_list==(this as any).ConferecneParticipantList.length ? true:false ; 
         }
        }

  async created() {
    this.$store.state.dashboard.Confrence_On = false;
      (this as any).ConferecneParticipantList.splice(0,(this as any).ConferecneParticipantList.length);
    this.$store.commit("SET_CONFERENCE_STATE", true);
    //this.$store.dispatch("verifyJWT").then(r => {}).catch(() => {});
    this.$store.commit("CLEAR_CONFERENCE_PARTICIPANT_LIST");
      this.$store.commit("SET_ADMIN_LOADER", true);
    //   await this.$store.dispatch("getConferencedata").then(r => {
    //  //   this.reloadData(r.data.data)
    //   });
    }

  reloadData(condata)
  {
      var conferenceon = false;
      this.$data.Conference_ownername = condata.name;
      this.privateConfDuration = condata._read_only.duration;
      var dur = moment.duration(condata._read_only.duration, "seconds");
      if (condata._read_only.participants.length>0)
        this.$data.Participant_name = condata._read_only.participants[0].custom_channel_vars.owner_id;
      for (var i = 0; i < condata._read_only.participants.length; i++) {
        this.$store.state.dashboard.Confrence_On = true;
        var member_name = (this as any).conferenceattendeesectionlist.Users.find(
          function(element) {
            return (
              element.id === condata._read_only.participants[i].custom_channel_vars.owner_id
            );
          }
        );
        var _confrenceuser =typeof member_name === "undefined"? condata._read_only.participants[i].caller_id_name : member_name.label;
        conferenceon = true;
        var Name = _confrenceuser;
        var namearr = Name.split(" ");
        var Fname_L = namearr[0].substring(0, 1);
        var Lname_L = namearr.length > 1 ? namearr[1].substring(0, 1) : " ";

        var pdur = moment.duration( condata._read_only.participants[i].duration, "seconds" ); 
        //moment.duration(condata._read_only.duration).asSeconds();
        var vrandomcolor = "";
        var color = Math.floor(Math.random() * 16777216).toString(16);
        vrandomcolor = "hsl(" + Math.round(Math.random() * 359) + ",100%,50%)"; //'#000000'.slice(0, -color.length) + color;
        this.$data.styleobj = {
          "background-color": vrandomcolor
        };
        (this as any).ConferecneParticipantList.push({
          name: Name,
          code: Fname_L + Lname_L,
          number: condata._read_only.participants[i].caller_id_number,
          speak: condata._read_only.participants[i].conference_channel_vars.speak,
          hear: condata._read_only.participants[i].conference_channel_vars.hear,
          duration:condata._read_only.participants[i].duration,// this.alterTime() , //this.alterTime(pdur),
          participant_id: condata._read_only.participants[i].participant_id,
          member_id: condata._read_only.participants[i].conference_channel_vars.member_id,
          talking: false,
          talking_status:condata._read_only.participants[i].conference_channel_vars.talking,
          colorcode: this.$data.styleobj
        });
      }
      this.$data.Conference_Duration = conferenceon ? this.alterTime(dur) : 0;
      if (conferenceon) {
        let ms: any = moment.duration(dur, "seconds");
        setInterval(() => {
          this.$data.Conference_Duration = this.alterTime(ms);
          ms._milliseconds += 1000;
        }, 1000);
      }

      for (const obj of (this as any).ConferecneParticipantList) {
        let ms: any = moment.duration(obj.duration, "seconds");
        setInterval(() => {
          obj.duration = this.alterTime(ms);
          ms._milliseconds += 1000;
        }, 1000);
      }
  }

  alterTime(dur) {
    let time = dur; //moment.duration(957146, 'seconds');
     var result =(time as any).format("dd:hh:mm:ss");
          if (!isNaN(result))
              result= "00:"+result;
        return  result;  
       // return (time as any).format("dd:hh:mm:ss"); 
  }

  destroyed() {
    this.$store.commit("SET_CONFERENCE_STATE", false);
  }

  async lockUnlockConference() {
    const action = this.$data.Lock == false ? "lock" : "unlock";
     this.$data.Unlockall_loading=true;
    const payload = {
      action: action,
      member_id: 0,
      conferenceid: (this as any).conferencedata.id
    };
    await this.$store.dispatch("conferenceaction", payload).then(r => {
      this.$data.Unlockall_loading=false;
      this.$data.Lock = !this.$data.Lock;
    });
    
  }

  async muteUnmuteAll() {
    this.$data.muteall_loading=true;
    const action = this.$data.Mute_All == false ? "mute" : "unmute";
    const payload = {
      action: action,
      member_id: 0,
      conferenceid: (this as any).conferencedata.id
    };
    await this.$store.dispatch("conferenceaction", payload).then(r => {
      this.$data.muteall_loading=false;
      this.$data.Mute_All = !this.$data.Mute_All;
    });
  
    (this as any).ConferecneParticipantList.forEach(element => {
      element.speak = !this.$data.Mute_All;
    });
  }

  async kickAll() {
    const action  =   "kick" ;//"Kick";
    const payload = {
      action: action,
      member_id: 0,
      conferenceid: (this as any).conferencedata.id
    };
     await this.$store.dispatch("conferenceaction", payload).then(r => {
     
    });

    (this as any).ConferecneParticipantList.splice( 0,(this as any).ConferecneParticipantList.length );
    this.$store.state.dashboard.Confrence_On =  (this as any).ConferecneParticipantList.length > 0;
    //(this as any).ConferecneParticipantList=[];
  }

  async muteUnmuteMember(_member_id) {
    var targetobject = (this as any).ConferecneParticipantList.find(function(
      element
    ) {
      //this.$data.loading_statusbyid=element.member_id;
      return element.member_id === _member_id;
    });
    this.$data.loading_statusbyid = targetobject.member_id;
    const action = targetobject.speak ? "mute" : "unmute";
    this.$data.loadingmick = true;
    const payload = {
      action: action,
      member_id: _member_id,
      conferenceid: (this as any).conferencedata.id
    };
    // alert(JSON.stringify(payload))
    var r = await this.$store.dispatch("conferenceaction", payload).then(_ => {
      this.$data.loadingmick = false;
      
    });
    
    targetobject.speak = !targetobject.speak;
    if(!targetobject.speak)
       targetobject.talking=false;

    var unmutecount = 0;
    (this as any).ConferecneParticipantList.forEach(element => {
      if (element.speak) unmutecount++;
    });
    this.$data.Mute_All = unmutecount === 0;
  }

  async deafUndeafMember(_member_id) {
    var targetobject = (this as any).ConferecneParticipantList.find(function(
      element
    ) {
      return element.member_id === _member_id;
    });
    this.$data.loading_statusbyid = targetobject.member_id;
    const action = targetobject.hear ? "deaf" : "undeaf";
    this.$data.loadingheadphn = true;
    const payload = {
      action: action,
      member_id: _member_id,
      conferenceid: (this as any).conferencedata.id
    };
    var r = await this.$store.dispatch("conferenceaction", payload).then(_ => {
      this.$data.loadingheadphn = false;
      
    });
    targetobject.hear = !targetobject.hear;
  }

  async kickMember(_member_id, name) {
    const action = "kick";
    const payload = {
      action: action,
      member_id: _member_id,
      conferenceid: (this as any).conferencedata.id
    };
    var r = await this.$store.dispatch("conferenceaction", payload).then(_ => {
      var targetobject = (this as any).ConferecneParticipantList.find(function(
        element
      ) {
        return element.member_id === _member_id;
      });

      (this as any).ConferecneParticipantList = (this as any).ConferecneParticipantList.filter(
        element => element.member_id != _member_id
      );
      /* (this as any).ConferecneParticipantList = (this as any).ConferecneParticipantList.filter(function(elm, index, arr){

                       return elm.member_id != _member_id;

                });*/

      for (var i = 0; i < (this as any).ConferecneParticipantList.length; i++) {
        if (
          (this as any).ConferecneParticipantList[i].member_id === _member_id
        ) {
          (this as any).ConferecneParticipantList.splice(i, 1);   
        }
      }
     
    });

    this.$store.state.dashboard.Confrence_On =
      (this as any).ConferecneParticipantList.length > 0;
  }
}
